import { PlayButton } from '@southfields-digital/mpxlive-components';

type Props = {
  playlistGraphic: PlaylistGraphic;
  liveIn: () => void;
  liveOut: () => void;
  swap: () => void;
};

export default function Controls({ playlistGraphic, liveIn, liveOut, swap }: Props) {
  if (playlistGraphic.status.live) {
    return (
      <div className="flex gap-1">
        <PlayButton
          hasIcon={false}
          variant="live"
          onClick={liveOut}
          isRunning
          className="w-full justify-center !p-1 !text-xs"
        >
          Out
        </PlayButton>
        <PlayButton
          hasIcon={false}
          variant="live"
          onClick={swap}
          isRunning={false}
          className="w-full justify-center !p-1 !text-xs"
        >
          Swap
        </PlayButton>
      </div>
    );
  }

  return (
    <PlayButton
      hasIcon={false}
      variant="live"
      onClick={liveIn}
      isRunning={false}
      disabled={playlistGraphic.isConcept}
      className="w-full justify-center !p-1 !text-xs"
    >
      Live in
    </PlayButton>
  );
}
